<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LlASBG/tc-custom/9781504042086.jpg?1701061116077" alt="This image is the cover for the book Graveyard Shift"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Graveyard Shift
      </h1>
      <p class="bookDescription body article font2">
        <b>A detective takes on a vengeful ex-con in London’s seedy underworld in this classic thriller by the <i>New York Times</i>–bestselling author of <i>The Midnight Bell</i>. </b><br/><br/> After nine years in prison, thief Ben Garvald has been released, and he’s headed back to the old neighborhood. His remarried ex-wife and sister-in-law aren’t happy about it, and they’ve asked for police protection. Det. Sgt. Nick Miller, meanwhile, is hopeful; this may be an opportunity to finally locate the stolen money that was never recovered after Garvald’s last heist. But a colleague of Miller’s is jealous: He wants to crack the case himself, and will risk endangering everyone to do so.<br/>  <br/> Miller’s highly unorthodox methods are perfectly suited for the graveyard shift, the midnight hours when the driven and desperate come out to play. Tonight, his toughest opponent will be Garvald—and only one of them will live to see the dawn.<br/>  <br/> From the author of such blockbusters as <i>The Eagle Has Landed</i> and the Sean Dillon novels, including <i>Rain on the Dead</i>, this is a hardboiled detective tale—originally published under the name Harry Patterson—in which the master of international intrigue focuses on one criminal, one cop, and a fast-paced cat-and-mouse game.<br/>  <br/><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Higgins
      </h2>
      
      <p class="authorDescription body article"><P> Jack Higgins is the <I>New York Times</I> bestselling author of more than sixty thrillers that have sold over 250 million copies worldwide, including <I>The Eagle Has Landed</I> and <I>The Wolf at the Door</I>. Before beginning his writing career, Higgins served in the British Army along the East German border. He lives in the Channel Islands. </P><P> &#160; </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35fc2212